export default "__VITE_ASSET__Bz9872Zs__"